import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight, Download } from "lucide-react";

const LINKS = [
    { label: "Home", href: "#home" },
    { label: "About Us", href: "#about" },
    { label: "Products", href: "#products" },
    { label: "Custom Manufacturing", href: "#manufacturing" },
    { label: "Projects", href: "#projects" },
    { label: "Catalogs", href: "#catalogs" },
    { label: "Contact Us", href: "#contact" },
];

const CATALOG_URL = `${process.env.REACT_APP_BACKEND_URL}/api/catalog`;

export const Nav = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <header
                data-testid="site-header"
                className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-line"
            >
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
                    <a href="#home" data-testid="nav-logo" className="flex flex-col leading-none">
                        <span className="font-heading font-extrabold tracking-tight text-lg text-navy">
                            ZAM ZAM FURNITURES
                        </span>
                        <span className="font-mono text-[10px] tracking-[0.3em] text-gold mt-1">
                            TASKLANCE® · EST. HYDERABAD
                        </span>
                    </a>

                    <nav className="hidden xl:flex items-center gap-7" data-testid="nav-links">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-[13px] font-medium tracking-wide text-charcoal hover:text-gold transition-colors duration-300"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden xl:flex items-center gap-3">
                        <a
                            href="#catalogs"
                            data-testid="download-catalog-button"
                            className="inline-flex items-center gap-2 px-5 py-2.5 border border-navy text-navy text-[13px] font-medium tracking-wide hover:bg-navy hover:text-white transition-colors duration-300"
                        >
                            <Download size={14} /> Catalogs
                        </a>
                        <a
                            href="#contact"
                            data-testid="get-quote-button"
                            className="group inline-flex items-center gap-2 px-5 py-2.5 bg-navy text-white text-[13px] font-medium tracking-wide hover:bg-gold transition-colors duration-300"
                        >
                            Get a Quote
                            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                    </div>

                    <button
                        data-testid="mobile-menu-button"
                        onClick={() => setOpen(!open)}
                        className="xl:hidden p-2 text-navy"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="mobile-menu"
                        initial={{ opacity: 0, y: -12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -12 }}
                        transition={{ duration: 0.25 }}
                        className="fixed inset-0 z-40 bg-navy pt-[96px] px-8 xl:hidden"
                    >
                        <nav className="flex flex-col gap-6">
                            {LINKS.map((l, i) => (
                                <motion.a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    initial={{ opacity: 0, x: -16 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.05 * i }}
                                    className="font-heading text-3xl font-bold text-white tracking-tight"
                                >
                                    {l.label}
                                </motion.a>
                            ))}
                            <a
                                href="#contact"
                                onClick={() => setOpen(false)}
                                data-testid="mobile-get-quote-button"
                                className="mt-4 inline-flex w-fit items-center gap-2 px-7 py-4 bg-gold text-white font-medium tracking-wide"
                            >
                                Get a Quote <ArrowUpRight size={16} />
                            </a>
                        </nav>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};
